import React from "react";

import styles from "../../../../styles/integrations.module.scss";
import sortStyles from "../../../../styles/sort-items.module.scss";
import bannerStyles from "../../../../styles/banners-drawer.module.scss";

import { Drawer } from "../../../components/Drawer";
import { Button } from "../../../components/Button";
import { ImageUpload } from "../../../components/ImageUpload";
import { EnvironmentsAPI } from "../../../../providers/EnvironmentsAPI";
import { EnvironmentStorage } from "../../../tools/EnvironmentStorage";
import { Hairline } from "../../../components/Hairline";
import { Icon } from "../../../components/core/Icon";

export default class BrandBannerTotemDrawer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            active: true,
            merchantId: "",
            portrait: [],
            landscape: [],
        };
    }

    async componentDidMount() {
        const environment = await EnvironmentStorage.getEnvironment();
        const frontTheme = await EnvironmentsAPI.getConfigurationsByAlias(
            environment.id,
            "bannersTotem"
        );
        this.setState({
            portrait: frontTheme?.portrait || [],
            landscape: frontTheme?.landscape || [],
        });
    }

    async updateBanners() {
        const { portrait, landscape } = this.state;
        const environment = await EnvironmentStorage.getEnvironment();
        this.setState({ loading: true });
        let bannersTotem =
            (await EnvironmentsAPI.getConfigurationsByAlias(
                environment.id,
                "bannersTotem"
            )) || {};
        bannersTotem = {
            portrait: portrait,
            landscape: landscape,
        };

        const updateResponse = await EnvironmentsAPI.putConfigurationsByAlias(
            environment.id,
            "bannersTotem",
            { bannersTotem }
        );

        if (updateResponse.getErrors([]).length > 0) {
            alert({ text: updateResponse.getErrors()[0], buttonText: "Ok" });
            this.setState({ loading: false });
            return false;
        } else {
            alert({ text: "Banners salvos com sucesso", buttonText: "Ok" });
        }

        this.setState({ loading: false });

        return true;
    }

    onRemoveBanner(bannerIndex, isMobile = true) {
        const { portrait, landscape } = this.state;
        if (isMobile) {
            this.setState({
                portrait: portrait.filter(
                    (_, imageIndex) => imageIndex != bannerIndex
                ),
            });
        } else {
            this.setState({
                landscape: landscape.filter(
                    (_, imageIndex) => imageIndex != bannerIndex
                ),
            });
        }
    }

    onSwitchPosition(bannerIndex, direction, isMobile = true) {
        const { portrait, landscape } = this.state;
        const newIndex = direction == "up" ? bannerIndex - 1 : bannerIndex + 1;
        if (isMobile) {
            const currentBannerOnPosition = portrait[bannerIndex];
            const newBannerOnPosition = portrait[newIndex];
            portrait[newIndex] = currentBannerOnPosition;
            portrait[bannerIndex] = newBannerOnPosition;
            this.setState({ portrait });
        } else {
            const currentBannerOnPosition = landscape[bannerIndex];
            const newBannerOnPosition = landscape[newIndex];
            landscape[newIndex] = currentBannerOnPosition;
            landscape[bannerIndex] = newBannerOnPosition;
            this.setState({ landscape });
        }
    }

    render() {
        const { loading, portrait, landscape } = this.state;
        const { visible, onClose } = this.props;

        return (
            <Drawer
                visible={visible}
                onClose={onClose}
                closeInFade
                title="Banners Totem"
            >
                <div className={styles.integration}>
                    <div>
                        <div className={bannerStyles.titleContainer}>
                            <p>Retrato</p>
                        </div>
                        {portrait.map((b, i, bArray) => {
                            return (
                                <div
                                    className={bannerStyles.bannerCard}
                                    key={i}
                                >
                                    <div className="w-100">
                                        <div className={bannerStyles.image}>
                                            <img
                                                src={`${process.env.REACT_APP_ASSETS_URL}/${b}`}
                                            />
                                        </div>
                                    </div>
                                    <div
                                        className={"d-flex"}
                                        style={{ padding: 10 }}
                                    >
                                        <div
                                            className={`${sortStyles.chevrons} w-100`}
                                        >
                                            {i !== 0 ? (
                                                <Icon
                                                    name="chevron-up"
                                                    size="lg"
                                                    onClick={() =>
                                                        this.onSwitchPosition(
                                                            i,
                                                            "up"
                                                        )
                                                    }
                                                />
                                            ) : (
                                                ""
                                            )}
                                            {i !== bArray.length - 1 ? (
                                                <Icon
                                                    name="chevron-down"
                                                    size="lg"
                                                    onClick={() =>
                                                        this.onSwitchPosition(
                                                            i,
                                                            "down"
                                                        )
                                                    }
                                                />
                                            ) : (
                                                ""
                                            )}
                                        </div>
                                        <Icon
                                            name="trash-alt"
                                            size="1x"
                                            onClick={() =>
                                                this.onRemoveBanner(i)
                                            }
                                        />
                                    </div>
                                </div>
                            );
                        })}
                        <ImageUpload
                            key={`mobile-1`}
                            onImageUpload={uri =>
                                this.setState({ portrait: [...portrait, uri] })
                            }
                            validateSize
                            height={1920}
                            width={1080}
                        />
                    </div>
                    <Hairline />
                    <div>
                        <div className={bannerStyles.titleContainer}>
                            <p>Paisagem</p>
                        </div>
                        {landscape.map((b, i, bArray) => {
                            return (
                                <div
                                    className={bannerStyles.bannerCard}
                                    key={i}
                                >
                                    <div className="w-100">
                                        <div className={bannerStyles.image}>
                                            <img
                                                src={`${process.env.REACT_APP_ASSETS_URL}/${b}`}
                                            />
                                        </div>
                                    </div>
                                    <div
                                        className={"d-flex"}
                                        style={{ padding: 10 }}
                                    >
                                        <div
                                            className={`${sortStyles.chevrons} w-100`}
                                        >
                                            {i !== 0 ? (
                                                <Icon
                                                    name="chevron-up"
                                                    size="lg"
                                                    onClick={() =>
                                                        this.onSwitchPosition(
                                                            i,
                                                            "up",
                                                            false
                                                        )
                                                    }
                                                />
                                            ) : (
                                                ""
                                            )}
                                            {i !== bArray.length - 1 ? (
                                                <Icon
                                                    name="chevron-down"
                                                    size="lg"
                                                    onClick={() =>
                                                        this.onSwitchPosition(
                                                            i,
                                                            "down",
                                                            false
                                                        )
                                                    }
                                                />
                                            ) : (
                                                ""
                                            )}
                                        </div>
                                        <Icon
                                            name="trash-alt"
                                            size="1x"
                                            onClick={() =>
                                                this.onRemoveBanner(i, false)
                                            }
                                        />
                                    </div>
                                </div>
                            );
                        })}
                        <div style={{ marginBottom: 50 }}>
                            <ImageUpload
                                key={`desktop-2`}
                                onImageUpload={uri =>
                                    this.setState({
                                        landscape: [...landscape, uri],
                                    })
                                }
                                validateSize={true}
                                width={1920}
                                height={1080}
                            />
                        </div>
                    </div>
                    <div className={styles.footer}>
                        <Button
                            design="primary"
                            className="w-100"
                            onClick={() => this.updateBanners()}
                            loading={loading}
                            disabled={loading}
                        >
                            Salvar
                        </Button>
                    </div>
                </div>
            </Drawer>
        );
    }
}
